import { render, staticRenderFns } from "./edit-box.vue?vue&type=template&id=7f04da89&"
import script from "./edit-box.js?vue&type=script&lang=js&"
export * from "./edit-box.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports